import { render, staticRenderFns } from "./GridAsignacion.vue?vue&type=template&id=426b1b38&"
import script from "./GridAsignacion.vue?vue&type=script&lang=js&"
export * from "./GridAsignacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports